import { registerRootComponent } from 'expo';
import 'react-native-gesture-handler';

import 'react-native-get-random-values';

import App from './src/App';
import polyfillNetworkInspect from './src/libs/polyfillNetworkInspect';

polyfillNetworkInspect();

// registerRootComponent calls AppRegistry.registerComponent('main', () => App);
// It also ensures that whether you load the app in Expo Go or in a native build,
// the environment is set up appropriately
registerRootComponent(App);
